module.exports = __webpack_public_path__ + "img/公众号二维码.6b849e66.jpg";